import script from "./EditUsersComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUsersComponent.vue?vue&type=script&setup=true&lang=js"

import "./EditUsersComponent.vue?vue&type=style&index=0&id=9adb41b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9adb41b0"]])

export default __exports__